module.exports = "/build/web/svg/sold_out--blue.34b83a24603596701c8032d95d95ad0e.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sold_out--blue.svg
// module id = 203
// module chunks = 24